<template>

   
      


  <div :class="itemClass" @click="addCartItem">
    <quantity :currentquantity="cartItem.quantity" @select="updatequantity" v-if="!productsAsSeparateItems"/>
    <label v-if="cartItem.seatNumber>0">  S{{ cartItem.seatNumber }}</label>
    <!-- <label for class="item-item">{{ cartItem.quantity }}</label> -->
      
      <div class="horizFlex">
          <label for class="item-item">{{ cartItem.name }}</label>
          
          <img alt="fire image" src="@/assets/fire.png" class="fireimg" v-if="cartItem.isInKitchen"/>
          <label v-if="cartItem.isFinancialAidEligible"> *FA*</label>
          <label v-if="cartItemIsExchange(cartItem)" class="discountcolor"> *Exchange*</label>
        </div>
        
    
    
    
    <label for class="item-net">{{ cartItem.unitPrice | toCurrency }}</label>
    
    <removebutton  @click="remove" class="removebutton" v-if="showButtons && !isRelatedCartItem"/>
    <!-- <linkbutton toplabel="Refund" @click="refund" v-if="showRefund"/> -->
    <admindiscount :item="cartItem"  :itemDiscounts="ticket.lineItemDiscounts" :ticketId="ticket.id" :businessDayId="ticket.businessDayId" @refresh="refresh" v-if="ShowAdminLineItemDiscount && showButtons && !cartItem.isGiftCard"/>
    <!-- <div class="buttons" v-show="isSelected"></div> -->
    <div class="subtext horizFlex" v-if="cartItem.selectedProductOptions!=null">
        <label v-if="cartItem.productOptionsString!=null">{{ cartItem.productOptionsString }}</label>
        <div class="margin5">
          <productoptions v-if="cartItem.selectedProductOptions!=null" :lineItemId="cartItem.lineItemId" :options="cartItem.selectedProductOptions" :showButton="paramTrue" @save="saveOptions" :productName="cartItem.name"/>
        </div>
        
    </div>
      
    <!-- option note -->
    <div class="subtext horizFlex" v-if="showOptionNote && !isRelatedCartItem">
      <div class="vertFlex">
        <label  v-if="cartItem.optionNote!=null">{{ cartItem.optionNote }}</label>
      
        <lineitemnote :ticketLineItemId="cartItem.lineItemId" :optionNote="cartItem.optionNote" @notesaved="notesaved" class="editoptionnote"/>
      </div>
    </div>

     <confirm ref="confirmremoveexchange" :showButton="falseParam"  body="This is an exchange item. Do you want to continue and remove both items?" title="Remove Exchange Items" @yes="removeexchange()"/>   
  </div>
</template>

<script>
import format from '../../style/format.js'
import removebutton from '../controls/removebutton.vue'
import {mapFields} from 'vuex-map-fields'
import admindiscount from '../actions/adminDiscount.vue'
import quantity from '../actions/quantity.vue'
import linkbutton from '../controls/linkbutton.vue'
import productoptions  from './productoptions.vue'
import pos from '../../services/pos.js'
 import pos_culinary from '../../services/pos_culinary.js'
 import confirm from '../actions/confirm.vue'
 import lineitemnote from './lineitemnote.vue'

export default {
  
  // props: ["cartItem"],
  props:{
           
      cartItem:{
          type:Object,
          
      },
      showButtons:{
        type:Boolean,
        default:true
      }
  },
  computed: {
    ...mapFields([
            'cartItems',
            'ticket',
            'responseMessage'
            
        ]),
    /* isSelected: function() {
  
      return this.cartItem.selected;
    }, */
    itemClass: function() {
      return this.cartItem.isAuto ? "item_cart selecteditem" : "item_cart";
    },
    ShowAdminLineItemDiscount(){
      if(window.SHOW_ADMIN_LINEITEM_DISCOUNT==undefined){return false}
      else{return window.SHOW_ADMIN_LINEITEM_DISCOUNT}
    },
    showRefund(){
      if(window.SHOW_REFUND==undefined){return false}
      else{return window.SHOW_REFUND}
    },
    showOptionNote(){
      if(window.SHOW_LINEITEM_OPTION_NOTE==undefined){return false}
      else{return window.SHOW_LINEITEM_OPTION_NOTE}
    },
    isRelatedCartItem(){
      if(this.cartItem.ticketLineItemId_Related>0){return true}
      else{return false}
    }
  },
  data(){
        return{
            paramTrue:true,
            falseParam:false
        }
    },
  mixins:[format,pos_culinary,pos],
  components:{
    removebutton,
    admindiscount,
    quantity,
    linkbutton,
    productoptions
    ,confirm,
    lineitemnote
  },
  methods: {
    notesaved(note){
      console.log('note saved ' + note)
      this.cartItem.optionNote=note
      this.$emit('refresh')
    },
    addCartItem(){
      console.log('add')
      this.$emit('additem',this.cartItem.id)
    },
    remove(){
      this.responseMessage=null
      if(this.cartItemIsExchange(this.cartItem)){

        this.$refs.confirmremoveexchange.Show()
      }else{
        this.$emit('removeitem',this.cartItem.id)
      }

      
      
    },
    removeexchange(){
      this.$emit('removeitem_exchange',this.cartItem.lineItemId, this.cartItem.ticketLineItemId_Exchange)
    },
    refund(){
      console.log('inrefund')
      this.$emit('refunditem',this.cartItem.lineItemId)
    },
    refresh(){
      this.$emit('refresh')
    },
    updatequantity(qty){

      this.$emit('updatequantity',this.cartItem,qty)
      this.$forceUpdate()
    },


  },
  
};
</script>

<style scoped>
/* .item_cart {
  margin: var(--margin-smaller);
  border: var(--border-default);
  border-radius: var(--border-radius-default);
  padding: var(--padding-default);
  background-color: var(--);
  color:var(--font-color-light);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width:100px;

} */
.item_cart {
  margin: var(--margin-smaller);
  border: var(--border-default);
  border-radius: var(--border-radius-default);
  padding: var(--padding-default);
  background-color: white;
  color:black;
  /* color:var(--font-color-light); */
  display: grid;
  grid-template-columns: 1fr 4fr 2fr 1fr auto;
  grid-template-rows: auto;
  min-width:100px;

}
.itemheader {
  font-weight: bold;
  margin: var(--margin-default);
}

.item-item {
  text-align: left;
}
.item-net {
  text-align:right;
}

.item-hr {
  grid-area: hr;
}
.buttons {
  grid-area: buttons;
}
.selecteditem {
  border-color: blue;
  border-width: 1;
}
.removebutton{
  margin-left:10px;
  margin-top:2px;
}
.subtext{
  font-size:small;
  grid-column:2/6;
  text-align: left;


}
.margin5{
  margin:0px 5px 5px 5px;
}
.editoptionnote{
  margin-top:5px;
}
</style>
